// import InfoIcon from "Assets/Icons/InfoIcon";
import LeftArrow from "Assets/Icons/LeftArrow";
import SearchCrossIcon from "Assets/Icons/SearchCrossIcon";
import SearchIcon from "Assets/Icons/SearchIcon";
import Typography from "Components/CommonComponents/Typography";
import { useRef, useState } from "react";
import { Card, Col, Row, Spinner } from "reactstrap";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
// import ReportLog from "./ReportLogo.svg";
import moment from "moment";

function AttendanceHeader({
  scheduledata,
  handleSearchStudent,
  handleBacknavigation,
}: // setIsUnmarkedVisible,
// handleUnmarkFilterForStudent,
any) {
  // const [tooltipOpen, setTooltipOpen] = useState(false);
  // const toggle = () => setTooltipOpen(!tooltipOpen);
  const { screen }: any = useWindowSize();
  const inputSearchRef = useRef<HTMLInputElement>(null);
  const [input, setInput] = useState<string>("");
  const isLoader = false;
  console.log("scheduledata", scheduledata);
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const { eventName, batchName, eventType, startTime, endTime } = scheduledata;
  const eventNameForHeader = eventType === "Lecture" ? eventName : eventType;
  const handleChange = (e: any) => {
    const { value } = e.target;
    if (value != null) {
      handleSearchStudent(value);
      setInput(value);
    }
  };
  // const NotMarkedChangeHandler = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const notMarked = event.target.checked;
  //   setIsUnmarkedVisible(notMarked);
  //   handleUnmarkFilterForStudent(notMarked);
  // };
  const SearchCrossButtonHandler = () => {
    handleSearchStudent("");
    setInput("");
    SearchButtonHandler();
  };
  const SearchButtonHandler = () => {
    setShowSearch(!showSearch);
  };
  return (
    <>
      <Card className="d-flex mt-3 mb-3 attendance-header-main-conteniner">
        <div>
          <Row className="mb-0">
            <Col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              className="d-flex justify-content-start"
            >
              <div className="w-100 d-flex flex-row justify-content-between align-items-center">
                <div className="d-flex flex-row align-items-center">
                  <LeftArrow
                    className={"cursorHoverCSS mr-3 ml-1"}
                    onClick={() => {
                      handleBacknavigation();
                    }}
                  />

                  {["xxl", "xl", "lg"].includes(screen) && (
                    <div className="d-flex flex-column">
                      <div>
                        <Typography
                          variant={
                            ["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"
                          }
                          color="darkgray"
                        >
                          {eventNameForHeader}{" "}
                          {batchName ? "| " + batchName : ""}
                        </Typography>
                      </div>
                      <div className="d-flex flex-row">
                        <Typography
                          variant={
                            ["xxl", "xl", "lg"].includes(screen)
                              ? "subheading3"
                              : "forminfo"
                          }
                          color="gray"
                        >
                          <span>
                            {" "}
                            {convertTime(startTime, "D MMM, ddd")} |&nbsp;
                          </span>
                          <span className="pr-2">
                            {convertTime(startTime, "h:mm")} -
                          </span>
                          <span>{convertTime(endTime, "h:mm a")}</span>
                        </Typography>
                      </div>

                      {scheduledata?.updatedByEmail &&
                        scheduledata?.updatedAt && (
                          <div className="d-flex flex-row">
                            <Typography
                              variant={
                                ["xxl", "xl", "lg"].includes(screen)
                                  ? "subheading3"
                                  : "forminfo"
                              }
                              color="gray"
                            >
                              <span style={{ fontSize: "0.8em" }}>
                                <span>Last updated by </span>
                                <span>{scheduledata.updatedByEmail}</span>
                                <span> · </span>
                                <span>
                                  {scheduledata.updatedAt
                                    ? moment
                                        .utc(scheduledata.updatedAt)
                                        .utcOffset("+05:30")
                                        .fromNow()
                                    : ""}
                                </span>
                              </span>
                            </Typography>
                          </div>
                        )}
                    </div>
                  )}
                </div>

                {["xxl", "xl", "lg"].includes(screen) && (
                  <div className="d-flex flex-row">
                    <div className="position-relative">
                      <input
                        className="inputAutoSearch"
                        disabled={false}
                        type={"text"}
                        value={input}
                        onChange={handleChange}
                        placeholder={"Search Student"}
                        ref={inputSearchRef}
                      />
                      <div className="searchAndCloseIconDiv">
                        {isLoader ? (
                          <Spinner color="info" size="sm"></Spinner>
                        ) : (
                          <>
                            {input ? (
                              <SearchCrossIcon
                                className="cursorHoverCSS"
                                onClick={() => {
                                  SearchCrossButtonHandler();
                                }}
                              />
                            ) : (
                              <SearchIcon
                                style={{
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {!["xxl", "xl", "lg"].includes(screen) && (
                  <div className="d-flex flex-row w-100">
                    {showSearch ? (
                      <div className="position-relative w-100">
                        <input
                          className="inputAutoSearch"
                          disabled={false}
                          type={"text"}
                          value={input}
                          onChange={handleChange}
                          placeholder={"Search Student"}
                          ref={inputSearchRef}
                        />
                        <div className="searchAndCloseIconDiv">
                          {isLoader ? (
                            <Spinner color="info" size="sm"></Spinner>
                          ) : (
                            <>
                              <SearchCrossIcon
                                className="cursorHoverCSS"
                                onClick={() => {
                                  SearchCrossButtonHandler();
                                }}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex flex-column w-100">
                        <div>
                          <Typography
                            variant={
                              ["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"
                            }
                            color="black"
                          >
                            {eventName} | {batchName}
                          </Typography>
                        </div>
                        <div className="d-flex flex-row">
                          <Typography
                            variant={
                              ["xxl", "xl", "lg"].includes(screen)
                                ? "subheading3"
                                : "forminfo"
                            }
                            color="black"
                          >
                            <span>
                              {" "}
                              Date- {convertTime(startTime, "D MMM, ddd")}{" "}
                              |&nbsp;
                            </span>
                            <span className="pr-2">
                              Time- {convertTime(startTime, "h:mm")} -
                            </span>
                            <span>{convertTime(endTime, "h:mm a")} &nbsp;</span>
                          </Typography>
                        </div>
                      </div>
                    )}

                    {/* <div className="p-2 pe-auto d-flex align-items-center">
                    <img
                      src={ReportLog}
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                    />
                  </div> */}
                    {/* <div className="p-2 pe-auto d-flex align-items-center">
                      <Button
                        color="danger"
                        outline
                        size="sm"
                        style={{ marginLeft: "8px" }}
                        onClick={() => {
                          setIsModalOpen(true);
                        }}
                      >
                        <img src={ReportLog} />
                      </Button>
                    </div> */}
                    <div className="p-2 pe-auto d-flex align-items-center">
                      {!showSearch ? (
                        <div onClick={SearchButtonHandler}>
                          <SearchIcon />
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </>
  );
}
export default AttendanceHeader;
